import {Component, Input, OnInit, TemplateRef, ViewChild} from '@angular/core';
import { EmulatorMessage } from '../../../../../shared/models';
import {ChatBubbleService} from "../chat-bubble/chat-bubble.service";
import {SMS, USSD} from "../../../../../shared/utils/config";

@Component({
    selector: 'app-url-preview',
    templateUrl: './url-preview.component.html',
    styleUrls: ['./url-preview.component.scss']
})
export class UrlPreviewComponent implements OnInit {
  console = console;

  @Input() emulatorMessage: EmulatorMessage;
  @ViewChild(`urlPreviewContainer`, { static: true }) urlPreviewContainer!: TemplateRef<any>;

  urlPreviewData: {mainUrl: string, rootUrl: string, remainder: string} = null;
  public shouldShowCharCount = false;
  public charCount: number;

  constructor(public chatBubbleService: ChatBubbleService) {
  }

  ngOnInit(): void {
    this.checkURL();
    this.shouldShowCharCount = this.showCharacterCount();
    if (this.shouldShowCharCount) {
      this.charCount = this.getStringLength(this.getFullString());
    }
  }

  getStringLength(str) {
    if (!str) { return; }
    return str.replace(/(<([^>]+)>)/gi, '').trim().length;
  }

  private getFullString(): string {
    let str = '';
    if (this.urlPreviewData['mainUrl'] !== null) {
      str += this.urlPreviewData['mainUrl'];
    }
    if (this.urlPreviewData['rootUrl'] !== null) {
      str += this.urlPreviewData['rootUrl'];
    }
    if (this.urlPreviewData['remainder']) {
      str += this.urlPreviewData['remainder'];
    }
    return str;
  }

  checkURL() {
    if (this.emulatorMessage.mediaMetaData["bubbleType"] === "contact") {
      this.urlPreviewData = null;
      return
    }

    if (this.emulatorMessage.channelPayload) {
      this.urlPreviewData = {mainUrl: '', rootUrl: '', remainder: ''};
      if (this.emulatorMessage.channelPayload['event']) {
        this.urlPreviewData = this.chatBubbleService.urlPreview(this.emulatorMessage.channelPayload['event']['moText'][0]['content']);
        return this.urlPreviewData;
      }
      if (this.emulatorMessage.channelPayload['messages']) {
        this.urlPreviewData = this.chatBubbleService.urlPreview(this.emulatorMessage.channelPayload['messages'][0]['content']);
        return this.urlPreviewData;
      }
    }

    this.urlPreviewData = this.chatBubbleService.urlPreview(this.emulatorMessage.message);
    return this.urlPreviewData;
  }

  get direction() {
    return this.chatBubbleService.isUserMessage(this.emulatorMessage);
  }

  showCharacterCount(): boolean {
    return (
        !this.direction &&
        (this.emulatorMessage.channelId === USSD || this.emulatorMessage.channelId === SMS)
    );
  }

}
